const setItem = (name, value) => {
  if (!window) {
    return null;
  }

  return window.localStorage.setItem(name, typeof value === 'string' ? value : JSON.stringify(value));
};

const getItem = name => {
  if (!window) {
    return null;
  }

  const data = window.localStorage.getItem(name);

  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};

const removeItem = name => {
  if (!window) {
    return null;
  }
  return window.localStorage.removeItem(name);
};

const add = (name, value) => {
  const list = getItem(name) || [];
  list.push(value);
  return setItem(name, list);
};

const remove = (name, value) => {
  const list = getItem(name) || [];

  const newList = list.filter(item => {
    if (item && typeof item === 'object') {
      return !isEqualObject(item, value);
    }
    return item !== value;
  });

  return setItem(name, newList);
};

const get = name => getItem(name) || [];

const isEqualObject = (object1, object2) =>
  object1.length === object2.length && !Object.keys(object1).find(key => object1[key] !== object2[key]);

export const localStorage = { add, remove, get, getItem, setItem, removeItem };
